import React, { useState, useEffect, useRef } from 'react';

const CountUpAnimation = ({ end, duration = 2000, prefix = '', suffix = '' }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => {
      if (countRef.current) {
        observer.unobserve(countRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Robust parsing: extract digits from string (handles "100+", "+100", "[LO] 100+")
    const endStr = end.toString();
    const endValue = parseInt(endStr.replace(/[^0-9]/g, ''), 10);
    
    if (isNaN(endValue)) return;

    const startTime = Date.now();
    
    const timer = setInterval(() => {
      const timePassed = Date.now() - startTime;
      const progress = Math.min(timePassed / duration, 1);
      
      // Easing function: easeOutExpo
      const easeOut = (x) => (x === 1 ? 1 : 1 - Math.pow(2, -10 * x));
      
      const currentCount = Math.floor(easeOut(progress) * endValue);
      setCount(currentCount);

      if (progress === 1) {
        clearInterval(timer);
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration, isVisible]);

  return (
    <span ref={countRef}>
      {prefix}{count}{suffix}
    </span>
  );
};

export default CountUpAnimation;
